import { Route, Routes } from 'react-router';
import { UserRole } from '@/types';
import ProtectedRoute from '@/app/routing/ProtectedRoute';
import SettingsPage from '../pages/SettingsPage';
import CheckpointSettingsPage from '../pages/CheckpointSettingsPage';
import UserManagementPage from '../pages/UserManagementPage';
import AlertsPage from '../pages/AlertsPage';
import JiraBoardsPage from '../pages/JiraBoardsPage';

const SettingsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<SettingsPage />} />
      <Route path="checkpoints" element={<CheckpointSettingsPage />} />
      <Route path="alerts" element={<AlertsPage />} />
      <Route
        path="users"
        element={
          <ProtectedRoute requiredRoles={[UserRole.USER_ACCESS_MANAGER]}>
            <UserManagementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="jira-boards"
        element={
          <ProtectedRoute requiredRoles={[UserRole.JIRA_BOARD_MANAGER]}>
            <JiraBoardsPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default SettingsRoutes;
